import { Component, OnInit } from '@angular/core';
import { Editor, toHTML } from 'ngx-editor';
import { ChasideService } from 'src/app/services/chaside.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-chaside-interpretations',
  templateUrl: './chaside-interpretations.component.html',
  styleUrls: ['./chaside-interpretations.component.css']
})
export class ChasideInterpretationsComponent implements OnInit {
  public editor:Editor;
  public interpretations = [];
  public interpretation = {
    scale:"",
    title:"",
    text:""
  };
  public isEditing = false;
  public html;
  public editingIndex;

  constructor(
    private chasideService:ChasideService
  ) { }

  ngOnInit(): void {
    this.editor = new Editor();
    this.chasideService.getInterpretations().subscribe(
      resp=>{
        this.interpretations = resp;
      },
      err=>console.log(err)
    )
  }

  save(){
    if(this.interpretation){
      // let founded = false;
      // let i = 0;
      // for (let interpretation of this.interpretations){
      //   if (interpretation.scale == this.interpretation.scale){
      //     founded = true;
      //   }else if (!founded) i++;
      // }
      // if (!founded) {
      //   this.interpretations.push(this.interpretation)
      // }
      // else 
      var html;
      if (this.html.type == "doc"){
        html = toHTML(this.html);
      }else{
        html = this.html;
      }
      this.interpretation.text = html;
      if (!this.isEditing){
        this.interpretations.push(this.interpretation);
        this.chasideService.updateInterpretation(this.interpretation).subscribe(
          resp=>{
            Swal.fire("Agregado").then(
              resp=>{
                this.html="";
                this.interpretation = {
                  scale:"",
                  title:"",
                  text:""
                }
              }
            );
          },
          err=>console.log(err)
        )
      }else{
        this.chasideService.updateInterpretation(this.interpretation).subscribe(
          resp=>{
            Swal.fire("Actualizado").then(
              resp=>{
                this.interpretations[this.editingIndex] = this.interpretation;
                this.html="";
                this.interpretation = {
                  scale:"",
                  title:"",
                  text:""
                }
              }
            );
          },
          err=>console.log(err)
        )
      }
    }
  }

  editInterpretation(i, index){
    this.isEditing = true;
    this.html = i.text;
    this.interpretation.scale = i.scale;
    this.interpretation.title = i.title;
    this.editingIndex = index;
  }

  deleteInterpretation(i, index){
    this.chasideService.deleteInterpretation(i).subscribe(
      resp=>{
        this.interpretations.splice(index, 1);
      },
      err=>console.log(err)
    )
  }

}
